<template>
  <item-select v-model="dd"
               :style="multiple ? '' : 'width: 100px'"
               :options="options"
               :disabled="disabled"
               :multiple="multiple"
               :hints="hints"
               allow-create />
</template>
<script>
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeYear",
  mixins: [LibProductItem],
  props: {
    value: [Number, Array],
  },
  computed: {
    options() {
      return this.list || this.yearOptions()
    }
  }
}
</script>
